<template>
    <div id="app">
        <nav-bar v-if="!computedLoggedIn"></nav-bar>
        <cms-nav-bar v-if="computedLoggedIn" :key="componentKeyCmsNavbar"/>
        <reload-session :message="msg" v-if="userLoggedInOut"></reload-session>
        <router-view v-if="computedShowMainContent" :style="disableClicks"></router-view>
    </div>
</template>

<script>
  import NavBar        from './components/Navbar'
  import CmsNavBar     from './components/cms/CmsNavbar'
  import ReloadSession from './components/ReloadSession'
  import EventBus      from './static/js/event-bus'

  export default {
    name: 'app',
    components: {
      NavBar,
      ReloadSession,
      CmsNavBar
    },
    data () {
      return {
        componentKeyCmsNavbar: 0,
        userLoggedInOut: false,
        msg: '',
        disableClicks: {
          'pointer-events': 'auto'
        }
      }
    },
    methods: {
      // method for getting the dynamic value for text on tab
      setTabText () {
        this.get(this.apiPrefix, this.miscApiUrl, 'get-application-details')
          .then(resp => {
            document.title = resp.data.tab_text
          })
          .catch(err => {
            console.log(err)
          })
      },
    },
    async created () {
      if (await this.checkIfLogged()) {
        if (this.$router.currentRoute.path.search(/cms/) !== -1) {
          this.$router.push({name: this.$router.currentRoute.name})
        } else {
                this.$router.push({name: 'Dashboard'})
        }
      } else {
        if(this.$router.currentRoute.name === 'ResetPassword'){
          this.$router.push({name: this.$router.currentRoute.name})
        } else {
          this.$router.push({name: 'Main'});
        }
      }

      this.toggleSideBar()

      let self = this
      this.setTabText()
      this.$store.watch(function (state) {
        return state.auth.loggedIn
      }, () => {
        if (document.visibilityState === 'hidden') {
          self.userLoggedInOut = true
          self.disableClicks['pointer-events'] = 'none'

          if (!self.$store.getters.getAuth['loggedIn']) {
            self.msg = 'You have been signed out in another tab or window.'
          } else {
            self.msg = 'You have been signed in in another tab or window.'
          }
        }
      })
    },
    mounted () {
      // event-bus for updating tab title received from ApplicationSettings.vue
      EventBus.$on('UPDATE_TAB_TEXT', function (payload) {
        document.title = payload
      })
    }
  }
</script>

<style>

</style>
